import { render, staticRenderFns } from "./RazorPay.vue?vue&type=template&id=677b4060&"
import script from "./RazorPay.vue?vue&type=script&lang=js&"
export * from "./RazorPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports